
import * as bootstrap from "bootstrap"
import { useEffect, useRef } from "react"


type PopOverProps={
  className?:string
  title:string
  conent:string
  children?: React.ReactNode
}

export const PopOver: React.FC<PopOverProps> = (props) => {
    const popoverRef = useRef<any>(null)
    
    useEffect(() => {
        if(popoverRef && popoverRef.current){
            new bootstrap.Popover(popoverRef.current, {
                content: props.conent ? props.conent :  'no remark.',               
            })
        }      
    })
  
    return (
      <div className={props.className}>
          <div ref={popoverRef}>
              {props.children}
          </div>
      </div>
    )
}